import React, { useEffect, useState } from 'react';
import { FIELD_NAME } from '../../../constants/form-constants';
import { formService } from '../../../form-service';
import { TextInputExtended } from './core/text-input-extended';

interface Props {
	label?: string;
	required?: boolean;
	showProvince?: boolean;
}

export function CodigoPostalInput(props: Props) {
	const [province, setProvince] = useState('');

	const getProvinceFromPostalCode = (postalCode: string): string => {
		const code = parseInt(postalCode.substring(0, 2));
		const provinces: { [key: number]: string } = {
			1: 'Álava',
			2: 'Albacete',
			3: 'Alicante',
			4: 'Almería',
			5: 'Ávila',
			6: 'Badajoz',
			7: 'Baleares',
			8: 'Barcelona',
			9: 'Burgos',
			10: 'Cáceres',
			11: 'Cádiz',
			12: 'Castellón',
			13: 'Ciudad Real',
			14: 'Córdoba',
			15: 'A Coruña',
			16: 'Cuenca',
			17: 'Girona',
			18: 'Granada',
			19: 'Guadalajara',
			20: 'Gipuzkoa',
			21: 'Huelva',
			22: 'Huesca',
			23: 'Jaén',
			24: 'León',
			25: 'Lleida',
			26: 'La Rioja',
			27: 'Lugo',
			28: 'Madrid',
			29: 'Málaga',
			30: 'Murcia',
			31: 'Navarra',
			32: 'Ourense',
			33: 'Asturias',
			34: 'Palencia',
			35: 'Las Palmas',
			36: 'Pontevedra',
			37: 'Salamanca',
			38: 'Santa Cruz de Tenerife',
			39: 'Cantabria',
			40: 'Segovia',
			41: 'Sevilla',
			42: 'Soria',
			43: 'Tarragona',
			44: 'Teruel',
			45: 'Toledo',
			46: 'Valencia',
			47: 'Valladolid',
			48: 'Bizkaia',
			49: 'Zamora',
			50: 'Zaragoza',
			51: 'Ceuta',
			52: 'Melilla',
		};
		return provinces[code] || '';
	};

	const regExp = /\d{5}/gi;

	useEffect(() => {
		if (!props.showProvince) return;

		const unsubscribe = formService.subscribeToField(FIELD_NAME.CP, {
			onChange: (value) => {
				if (value?.length === 5) {
					setProvince(getProvinceFromPostalCode(value));
				} else {
					setProvince('');
				}
			},
		});

		return unsubscribe;
	}, [props.showProvince]);

	return (
		<TextInputExtended
			{...props}
			label={props.label || 'Código postal'}
			name={FIELD_NAME.CP}
			validate={(value) => regExp.test(value)}
			maxLength={5}
			errorMessage="Código postal incorrecto"
			secondaryMessage={props.showProvince ? (province ?? undefined) : undefined}
		/>
	);
}
